import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProductCallout from '~/shared/components/ProductCallout';

import { useProductCalloutOverlay } from '../../hooks/useProductCalloutOverlay';

const ProductCardCalloutWrapper = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.gridProductCardCalloutWrapperTextColor};
  font-weight: 400;
`;

const CalloutText = styled(ProductCallout)`
  font-size: 12px;
  text-transform: uppercase;
  display: block;
  width: fit-content;

  ${({ theme }) => theme.gridCellStyles.calloutText};
`;

const ProductCardCallout = ({ product }) => {
  const { callout, shouldShowCalloutOverlay } = useProductCalloutOverlay({
    product,
  });

  if (!product || !callout?.type || shouldShowCalloutOverlay) {
    return null;
  }

  return (
    <ProductCardCalloutWrapper>
      <CalloutText type={callout.type} value={callout.value} />
    </ProductCardCalloutWrapper>
  );
};

ProductCardCallout.propTypes = {
  product: PropTypes.shape({
    dateExpected: PropTypes.string,
    tagIdList: PropTypes.arrayOf(PropTypes.number),
    membershipBrandId: PropTypes.number,
    waitListAllowed: PropTypes.bool,
    skus: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        isPreorder: PropTypes.bool,
      })
    ),
    availableQuantity: PropTypes.number,
    availableQuantityMaster: PropTypes.number,
    productIdObjectList: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        availableQuantityPreorder: PropTypes.number,
      })
    ),
  }),
};

export default ProductCardCallout;
